import { ControlFacet } from '../models/controls/ControlFacet';
import { IComponentAs } from '@uifabric/utilities/lib/IComponentAs';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';
import { IFileTypeIconProps } from '../components/itemFileTypeIcon/ItemFileTypeIcon';

export interface IFileTypeIconControlProps {
  itemKey: string | undefined;
}

export interface IFileTypeIconControlOverrides {
  iconAs: IComponentAs<IIconProps>;
  fileTypeIconAs: IComponentAs<IFileTypeIconProps>;
}

export const itemFileTypeIconControl = new ControlFacet<
  IFileTypeIconControlProps,
  IFileTypeIconControlOverrides
  >('itemFileTypeIconControl', {
    iconAs: defaultRenderComponentOption<IIconProps>(),
    fileTypeIconAs: defaultRenderComponentOption<IFileTypeIconProps>()
  });
